module.exports = __webpack_public_path__ + "static/service_bg-592eaf050b3cf51fc09330d85387f715.png";